<template>
  <section>
    <b-row>
      <b-col>
        <div class="table-toolbar d-print-none" style="float: right">
          <a class="table-toolbar-control" @click="toolbar.open = !toolbar.open">
            <font-awesome-icon icon="bars" />
          </a>
          <div v-if="toolbar.open" class="table-toolbar-list">
            <a @click="download()"> Download Excel </a>
          </div>
        </div>

        <b-table striped hover :items="filteredTableItems">
          <template v-slot:cell(Vettore)="data">
            {{ vectorName(data.item.Vettore) }}
          </template>
          <template v-slot:cell(Totale)="data">
            {{ data.item.Totale }}
          </template>
          <template v-slot:cell()="data">
            {{ data.value.value }}
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-row v-if="series == -1">
      <b-col>
        <b-progress-bar :value="100" :max="100" variant="success" striped :animated="true">
          Caricamento dati in corso
        </b-progress-bar>
      </b-col>
    </b-row>

    <div ref="wrapper" class="main-chart-wrapper">
      <div class="main-chart mb-2">
        <div ref="wrapper-left" class="main-chart--expchild">
          <vue-resizable
            :fit-parent="false"
            :active="['r', 'b']"
            :min-width="273"
            :max-width="flexWidth"
            :min-height="250"
            @resize:end="eHandlerEnd"
          >
            <div class="resizable-content a">
              <div
                :style="{
                  height: minHeightDiv > chartWidthValue ? `${chartWidthValue}px` : `${minHeightDiv}px`,
                  width: minHeightDiv > chartWidthValue ? `${chartWidthValue}px` : `${minHeightDiv}px`,
                }"
              >
                <div style="height: 100%" :id="pieChartId"></div>
                <!-- <apexchart type="pie" ref="apexPie" :options="pieOptions" :series="pieSeries" :height="minHeightDiv > chartWidthValue ? chartWidthValue : minHeightDiv" :width="minHeightDiv > chartWidthValue ? chartWidthValue : minHeightDiv"></apexchart> -->
              </div>
            </div>
          </vue-resizable>
        </div>
        <div class="main-chart--notexpchild">
          <div :style="{ height: `${minHeightDiv}px` }">
            <div style="height: 98%" :id="chartId"></div>
            <!-- <apexchart ref="apex" type="bar" :options="options" :series="series" :height="minHeightDiv"></apexchart> -->
          </div>
        </div>
      </div>
    </div>

    <b-row v-if="series.length == []">
      <b-col>
        <b-alert :show="true" variant="warning">Nessun dato disponibile</b-alert>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import Vue from "vue";
var VueCookie = require("vue-cookie");
import VueApexCharts from "vue-apexcharts";
import { mapMutations } from "vuex";
import VueResizable from "vue-resizable";
import chart from "../Dashboard/VectorWidgets/widgets/chart";
import { makeid } from "./helpers";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4lang_it_IT from "@amcharts/amcharts4/lang/it_IT";
import { startRender, finishRender } from "../../helpers/printReady";

Vue.component("VueResizable", VueResizable);

var moment = require("moment");

export default {
  props: ["tep", "params"],
  data() {
    return {
      toolbar: { open: false },
      vectors: [],
      table: [],
      pieOptions: {
        chart: {
          toolbar: {
            show: true,
            tools: {
              download: true,
            },
          },
          width: "100%",
          height: "100%",
        },
        colors: this.$store.state.colors,
        labels: [],
        tooltip: {
          y: {
            formatter: (v) => {
              return v ? this.f(v) : "";
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
        legend: {
          show: false,
        },
      },
      options: {
        colors: this.$store.state.colors,
        chart: {
          stacked: true,
          toolbar: {
            show: true,
          },
          zoom: {
            enabled: true,
          },
          height: "100%",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          //type: 'datetime',
          categories: [],
          labels: {
            rotate: -45,
          },
        },
        yaxis: {
          labels: {
            formatter: (x) => this.f(x),
          },
        },
        legend: {
          formatter: (label) => this.getMu(label),
          position: "bottom",
          /*offsetY: 40*/
          itemMargin: {
            vertical: 15,
          },
        },
        fill: {
          opacity: 1,
        },
      },
      series: -1,
      pieSeries: [],
      parentHeight: 453,
      columnWidth: 339,
      chartWidth: 339,
      chartId: makeid(),
      pieChartId: makeid(),
      amBarChart: undefined,
      amPieChart: undefined,
      hiddenLegends: [],
    };
  },

  computed: {
    minHeightDiv() {
      return this.parentHeight;
    },
    chartWidthValue() {
      return this.chartWidth;
    },
    flexWidth() {
      return this.columnWidth;
    },
    filteredTableItems() {
      let tableCopy = _.cloneDeep(this.table);
      let newTableData = tableCopy
        .filter((ele) => !ele.hidden)
        .map((ele) => {
          delete ele.hidden;
          delete ele.name;
          return ele;
        });
      return newTableData;
    },
  },

  created() {
    window.addEventListener("resize", this.resizeEventHandler);
    if (this.tep) this.build();
  },

  mounted() {
    // Initialize chart section width when page load
    setTimeout(() => {
      this.resizeEventHandler();
    }, 1000);
  },

  beforeDestroy() {
    this.unload();
  },

  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },

  methods: {
    ...mapMutations({
      startLoading: "loading",
      stopLoading: "stopLoading",
    }),

    getMu(name) {
      return name + " " + this.$store.getters["vectors/getMuByName"](name);
    },

    resizeEventHandler(e) {
      let document = this.$refs["wrapper"];
      if (document !== undefined) {
        let result = document.clientWidth / 2;
        this.columnWidth = result;
      }
    },

    eHandlerEnd(data) {
      if (data.eventName == "resize:end") {
        this.parentHeight = data.height;
        this.chartWidth = data.width;
        // this.$refs['apex'].updateOptions(this.options);
        // this.$refs['apexPie'].updateOptions(this.pieOptions);
      }
    },

    vectorName(vector) {
      return this.$store.getters["vectors/getName"](vector);
    },
    build() {
      //this.startLoading();
      this.$store
        .dispatch("charts/monthlySiteValues", this.params)
        .then((response) => {
          if (!response.data) {
            this.$notify({
              type: "error",
              text: response.message,
              title: "Errore",
            });
            return;
          }

          this.table = [];
          this.series = [];
          this.pieSeries = [];

          let data = response.data;

          let options = _.cloneDeep(this.options);
          options.xaxis.categories = data.months.map((month) => {
            let m = month.split("-");
            let date = moment(m[1] + "-" + m[0] + "-01");
            return date.format("MMM YY");
          });

          this.options = options;
          this.series = [];

          /**
           * Table
           */
          this.vectors = _.uniq(data.values.map((v) => v[0]));
          this.vectors.forEach((vector) => {
            let row = {};

            row.Vettore = vector;
            row.name = this.vectorName(vector);
            row.hidden = false;
            var total = 0;
            data.months.forEach((month) => {
              let valueItem = data.values.find((v) => {
                return v[0] == vector && v[1] == month;
              });
              let value = valueItem ? valueItem[2].toFixed(2) : 0;
              let tep = valueItem ? valueItem[3].toFixed(2) : 0;
              let m = month.split("-");

              let date = moment(m[1] + "-" + m[0] + "-01");
              row[date.format("MMM YY")] = {
                value: this.f(tep),
                tep: this.f(tep),
                mu: row.mu,
              };
              total += parseFloat(tep);
            });

            row.Totale = this.f(total);
            this.table.push(row);
          });

          /**
           * Bar chart
           */
          this.vectors.forEach((vector) => {
            let serie = {
              name: this.vectorName(vector),
              data: [],
            };
            data.months.forEach((month) => {
              let value = data.values.find((v) => {
                return v[0] == vector && v[1] == month;
              });
              serie.data.push(value ? value[3] : 0);
            });

            this.series.push(serie);
          });

          /**
           * Pie chart
           */
          let pieOptions = _.cloneDeep(this.pieOptions);
          pieOptions.labels = this.vectors.map((v) => this.vectorName(v));

          this.pieOptions = pieOptions;
          this.vectors.forEach((vector) => {
            var total = 0;
            data.months.forEach((month) => {
              let value = data.values.find((v) => {
                return v[0] == vector && v[1] == month;
              });
              total += value ? value[3] : 0;
            });

            this.pieSeries.push(total);
          });
          this.setAmChartsData(data);
        })
        .finally(() => this.stopLoading());
    },
    f(v) {
      return this.$options.filters.formatDecimal(v);
    },
    download() {
      location.href =
        process.env.API +
        "/data/monthly-site-values/download?token=" +
        VueCookie.get("token") +
        "&from=" +
        this.params.fromMonth +
        "&to=" +
        this.params.toMonth +
        "&site=" +
        this.params.siteGuid;
    },
    setAmChartsData(respData) {
      let chartData = {
        mus: [""],
        columns: ["Date"],
        sources: [],
        values: respData.months.map((mon) => [mon]),
      };
      respData.values.forEach((ele, index) => {
        if (!chartData.columns.includes(ele[0])) {
          chartData.columns.push(ele[0]);
          chartData.sources.push("EE_12" + index);
        }
      });

      let pieData = [];

      for (let i = 1; i < chartData.columns.length; i++) {
        let column = chartData.columns[i];
        let pieValue = {
          name: this.vectorName(column),
          value: 0,
        };
        for (let j = 0; j < respData.months.length; j++) {
          let value = respData.values.find((ele, valueIndex) => {
            if (ele[0] == column && ele[1] == respData.months[j]) {
              return ele;
            }
          });
          if (i == 1) {
            let d = chartData.values[j][0].split("-");
            let date = `${d[1]}-${d[0]}-01`;
            chartData.values[j][0] = new Date(date);
          }
          chartData.values[j].push(Number(value[3].toFixed(2)));
          pieValue.value += Number(value[3].toFixed(2));
        }
        pieData.push(pieValue);
      }
      this.makeChart(this.chartId, chartData);
      this.makeAmPieChart(pieData);
    },
    makeChart(chartId, data) {
      this.colors = this.$store.state.colors;
      let chart = am4core.create(chartId, am4charts.XYChart);

      // Track async rendering for the Puppeteer print service.
      startRender();
      let renderSettled = false;
      const settleRender = () => {
        if (renderSettled) return;
        renderSettled = true;
        finishRender();
      };
      chart.events.on("ready", settleRender);
      setTimeout(settleRender, 8000);

      chart.language.locale = am4lang_it_IT;
      chart.colors.list = this.colors.map((e) => {
        return am4core.color(e);
      });
      chart.fontSize = 10;

      let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.cursorTooltipEnabled = false;
      dateAxis.renderer.grid.template.disabled = true;
      dateAxis.renderer.labels.template.adapter.add("text", (label, target, key) => {
        if (target.dataItem.value) {
          let labelValue = target.dataItem.value;
          let formattedDate = moment(labelValue).format("MMM YY");
          return formattedDate;
        }
      });
      dateAxis.renderer.minGridDistance = 30;
      // dateAxis.renderer.labels.template.rotation = -45;
      // dateAxis.renderer.labels.template.horizontalCenter = "right";
      // dateAxis.renderer.labels.template.verticalCenter = "middle";
      dateAxis.renderer.cellStartLocation = 0.2;
      dateAxis.renderer.cellEndLocation = 0.8;

      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = dateAxis;
      chart.numberFormatter.numberFormat = "#.";
      chart.legend = new am4charts.Legend();
      chart.exporting.menu = new am4core.ExportMenu();
      chart.series.clear();
      chart.legend.itemContainers.template.events.on("hit", (ev) => {
        let table = [...this.table];
        let name = ev.target.dataItem.dataContext.name;
        if (this.hiddenLegends.includes(name)) {
          let index = this.hiddenLegends.indexOf((ele) => ele == name);
          this.hiddenLegends.splice(index, 1);
        } else {
          this.hiddenLegends.push(name);
        }

        let newTable = table.map((ele) => {
          ele.hidden = this.hiddenLegends.includes(ele.name) ? true : false;
          return ele;
        });
        this.table = newTable;
        // let seriesColumn = ev.target.dataItem.dataContext.columns.template;
        // seriesColumn.isActive = !seriesColumn.isActive;
      });
      this.yAxis = {};
      data.mus.forEach((mu, index) => {
        if (!this.yAxis[mu]) {
          let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
          valueAxis.min = 0;
          valueAxis.name = data.columns[index + 1];
          valueAxis.title.text = "";
          valueAxis.title.fontWeight = 600;
          valueAxis.cursorTooltipEnabled = false;
          this.yAxis[mu] = valueAxis;
        }
      });
      this.createSeries(data, chart);
    },

    createSeries(data, chart) {
      try {
        data.sources.forEach((source, index) => {
          let series = chart.series.push(new am4charts.ColumnSeries());
          series.dataFields.valueY = source;
          series.tooltip.pointerOrientation = "vertical";
          series.name = this.vectorName(data.columns[index + 1]);
          series.dataFields.dateX = "date";
          series.columns.template.width = am4core.percent(100);
          series.stacked = true;
          series.tooltip.getFillFromObject = false;
          series.tooltip.autoTextColor = false;
          series.adapter.add("tooltipText", (text, target) => {
            var sum = target.tooltipDataItem.dataContext;
            let tooltipData = target.tooltipDataItem.dataContext;
            var seriesData = [];
            seriesData.push(sum.value.toString().split("."));
            var valueY = seriesData[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
            let strokeColor = target.stroke.hex;
            let dateFormat = this.getTooltipFormat(tooltipData.isComparing);
            var text = `${dateFormat}  \n [${strokeColor}]● [/] ${tooltipData.name} [bold]${valueY}[/]`;
            return text;
          });

          series.tooltip.label.fill = am4core.color("black");
          var series_data = [];

          data.values.forEach((item, valueIndex) => {
            var dataItem = {};
            dataItem.value = item[index + 1] ? item[index + 1].toFixed(2) : 0;
            dataItem.name = this.vectorName(data.columns[index + 1]);
            dataItem.date = item[0];
            dataItem[source] = item[index + 1];
            series_data.push(dataItem);
          });
          series.data = series_data;
        });
        this.amBarChart = chart;
      } catch (error) {
        console.log(error);
      }
    },

    getTooltipFormat() {
      return '{dateX.formatDate("MMM YYYY")}';
    },

    makeAmPieChart(data) {
      var chart = am4core.create(this.pieChartId, am4charts.PieChart);

      // Track async rendering for the Puppeteer print service.
      startRender();
      let pieRenderSettled = false;
      const settlePieRender = () => {
        if (pieRenderSettled) return;
        pieRenderSettled = true;
        finishRender();
      };
      chart.events.on("ready", settlePieRender);
      setTimeout(settlePieRender, 8000);

      chart.data = data;
      chart.fontSize = 10;
      chart.language.locale = am4lang_it_IT;
      chart.language.locale["_decimalSeparator"] = ",";
      chart.language.locale["_thousandSeparator"] = "'";

      var pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.labels.template.maxWidth = 130;
      pieSeries.labels.template.wrap = true;
      pieSeries.labels.template.fontSize = 11;
      chart.radius = am4core.percent(50);
      pieSeries.dataFields.value = "value";
      pieSeries.dataFields.category = "name";
      pieSeries.slices.template.stroke = am4core.color("#fff");
      pieSeries.slices.template.strokeOpacity = 1;

      pieSeries.tooltip.getFillFromObject = false;
      pieSeries.tooltip.autoTextColor = false;
      pieSeries.tooltip.label.fill = am4core.color("black");

      var colorSet = new am4core.ColorSet();
      colorSet.list = this.colors.map(function (color) {
        return new am4core.color(color);
      });
      pieSeries.colors = colorSet;

      pieSeries.ticks.template.disabled = false;
      pieSeries.alignLabels = true;
      pieSeries.labels.template.text = "{value.percent.formatNumber('#.0')}%";
      pieSeries.labels.template.radius = am4core.percent(0);
      //pieSeries.labels.template.fill = am4core.color("white");

      pieSeries.slices.template.tooltipText = `{category}: [bold] {value}`;

      var hs = pieSeries.slices.template.states.getKey("hover");
      hs.properties.scale = 1;

      chart.hiddenState.properties.radius = am4core.percent(0);
      this.amPieChart = chart;
    },

    unload() {
      if (this.amBarChart) {
        console.log("Disponsing bar chart");
        this.amBarChart.dispose();
        this.amBarChart = undefined;
      }
      if (this.amPieChart) {
        console.log("Disponsing pie chart");
        this.amPieChart.dispose();
        this.amPieChart = undefined;
      }
    },
  },
  watch: {
    params() {
      this.build();
    },
  },
  beforeDestroy() {
    this.unload();
  },
};
</script>

<style>
.resizable-content {
  height: 100%;
  width: 100%;
}

.main-chart {
  display: flex;
  flex-direction: row;
}

.main-chart .main-chart--expchild {
  flex: 0 1 auto;
}

.main-chart .main-chart--notexpchild {
  flex-grow: 1;
  max-height: 100%;
}

.a + .resizable-r {
  z-index: 0 !important;
  height: 80px !important;
  background-color: #d0dae3 !important;
  top: 50% !important;
  transform: translateY(-50%);
}

.resizable-b {
  z-index: 0 !important;
  background-color: #d0dae3 !important;
  height: 3px !important;
  bottom: 0 !important;
  left: 100% !important;
  width: 80px !important;
  transform: translateX(100%);
}

.main-chart-wrapper {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Diagnosi/Vectors.vue